// extracted by mini-css-extract-plugin
export default {"project-item":"styles_project-item__FRnUQ","project-item-btn":"styles_project-item-btn__cXvXW","active":"styles_active__IIBxi","project-title":"styles_project-title__36L1r"};